module.exports = __webpack_public_path__ + "images/2-h1095d65954d165c2eb1ad885ec12eb0d.svg";